import React from 'react';
import TaskList from './tasklist';

/** Same as Task List, but only shows tasks linked to a project. */
const ProjectTaskList = () => <TaskList projectTasksOnly />;

export default ProjectTaskList;
